whenAvailable('$', function() {
$(function () {
    function validateURL(url) {
        let result = false;
        const format = $('#modal_selector').attr('data-socialtype');

        if (/^https:\/\/(www\.|m\.)?facebook.com\/[a-zA-Z0-9-_.=\/?&]+/g.test(url) && format === 'facebook') {
            result = true;
        } else if (/^https:\/\/(www\.)?instagram.com\/(p|tv|reel)\/[a-zA-Z0-9-_]+(\/)*(\?igshid=[a-z0-9]+)*/g.test(url) && format === 'instagram') {
            // Sample Instagram Reel link: https://www.instagram.com/reel/CnCuKEajly7/?igshid=NTdlMDg3MTY=
            result = true;
        } else if (/^https:\/\/(www\.)?twitter.com\/[A-Za-z0-9_]+\/status\/[0-9]+/g.test(url) && format === 'twitter') {
            result = true;
        } else if (/^(https|http):\/\/(www\.)?(youtube.com\/watch\?v=\w*|youtu.be\/\w*)((&|\?)t=\d+)?/g.test(url) && format === 'youtube') {
            result = true;
        } else if (/^(https|http):\/\/(www\.)?youtube.com\/shorts\/[a-zA-Z0-9-_.]+(\?feature=[a-z0-9]+)*/g.test(url) && format === 'youtube') {
            // Sample Youtube Shorts link: https://youtube.com/shorts/VoT9ZlZUhcU?feature=share
            result = true;
        } else if (/^https:\/\/(www\.)?reddit.com\/r\/[a-zA-Z0-9-_\/]+/g.test(url) && format === 'reddit') {
            result = true;
        } else if (/^https:\/\/(www\.)?reddit.com\/user\/[a-zA-Z0-9-_\/]{3,20}\/comments\/[a-zA-Z0-9-_\/]+/g.test(url) && format === 'reddit') {
            result = true;
        } else if (/^https:\/\/(www\.)?twitch.tv\/[a-zA-Z0-9-_\/]{4,25}\/clip\/[a-zA-Z0-9-_\/]+/g.test(url) && format === 'twitch') {
            result = true;
        } else if (/^https:\/\/clips\.?twitch.tv\/[a-zA-Z0-9-_\/]+/g.test(url) && format === 'twitch') {
            result = true;
        } else if (/^https:\/\/vt\.?tiktok.com\/[a-zA-Z0-9-_\/]+/g.test(url) && format === 'tiktok') {
            // Sample mobile link: https://vt.tiktok.com/ZS8Mvu3kQ/
            result = true;
        } else if (/^https:\/\/www\.?tiktok.com\/[@a-zA-Z0-9-_.]+\/video\/[0-9]+/g.test(url) && format === 'tiktok') {
            // Sample desktop link: https://www.tiktok.com/@user.name/video/7184719262173383938
            result = true;
        } else if (/^https:\/\/blog\.?naver.com\/[a-zA-Z0-9-_\/]{3,20}\/[0-9]+/g.test(url) && format === 'naver') {
            result = true;
        }

        return result;
    }

    // SOCIAL MEDIA
    $('#sel_socialmedia').on('change', function() {
        switch (this.value) {
            case 'naver':
                $('#link_to_post').attr("placeholder", "e.g. https://blog.naver.com/secretlabkr/222029514659");
                $('#modal_selector').show().attr('data-socialtype', 'naver');
                break;
            case 'facebook':
                $('#link_to_post').attr("placeholder", "e.g. https://www.facebook.com/photo.php?fbid=10155929555839121");
                $('#modal_selector').show().attr('data-socialtype', 'facebook');
                break;
            case 'instagram':
                $('#link_to_post').attr("placeholder", "e.g. https://www.instagram.com/p/h23YH3wj23f");
                $('#modal_selector').show().attr('data-socialtype', 'instagram');
                break;
            case 'twitter':
                $('#link_to_post').attr("placeholder", "e.g. https://twitter.com/username/status/1236582790234234658");
                $('#modal_selector').show().attr('data-socialtype', 'twitter');
                break;
            case 'twitch':
                $('#link_to_post').attr("placeholder", "e.g. https://clips.twitch.tv/JohnSmithAndHisSecretlabChair");
                $('#modal_selector').show().attr('data-socialtype', 'twitch');
                break;
            case 'youtube':
                $('#link_to_post').attr("placeholder", "e.g. https://youtu.be/45Ku0vfCHtc?t=10");
                $('#modal_selector').show().attr('data-socialtype', 'youtube');
                break;
            case 'reddit':
                $('#link_to_post').attr("placeholder", "e.g. https://www.reddit.com/r/JohnSmithAndHisSecretlabChair");
                $('#modal_selector').show().attr('data-socialtype', 'reddit');
                break;
            case 'tiktok':
                $('#link_to_post').attr("placeholder", "e.g. https://vt.tiktok.com/ZS8Mvu3kQ/");
                $('#modal_selector').show().attr('data-socialtype', 'tiktok');
                $('#link_format').text('TikTok');
                break;
            default:
                $('#link_to_post').attr("placeholder", "Social media public post/video link");
                $('#modal_selector').hide();
        }
    });

    $('#link_to_post').on('change', function() {
        if (!validateURL($(this).val())) { 
            $(this).addClass('is-invalid');
            $(this).get(0).setCustomValidity('Please provide a valid URL.');
        } else { 
            $(this).removeClass('is-invalid'); 
            $(this).get(0).setCustomValidity('');
        }
    });

    // MODAL
    $('#modal_socialmedia').on('show.bs.modal', function (e) {
        const type = $(e.relatedTarget).attr('data-socialtype');
        $('.modal-content-media').hide();
        $('#modal-content-' + type).show();

        if (type === 'youtube') {
            $('.title-platform').text('YouTube');
        } else if (type === 'naver') {
            if (shop_locale == 'en') {
                $('.title-platform').text('Naver Blog');
            } else {
                $('.title-platform').text('Naver 블로그');
            }
        } else {
            $('.title-platform').text(type);
        }
    });

    const $submit_button = $('#form_submit'),
          $main_form = $('#redeem_form');

    $submit_button.on('click', function(){ $.validateForm('#redeem_form'); });
    $main_form.submit(function (e) {
        e.preventDefault();

        const formData = new FormData(this);
        $.submitForm('https://beans.secretlab.co/index.php/api/magnus_advocacy', formData, $main_form);
    });
});
});